<h1 mat-dialog-title cdkDrag cdkDragRootElement='.cdk-overlay-pane' cdkDragHandle>Ændre rabat</h1>
<button class='btn-close btn-icon' mat-dialog-close title='Luk dialog'>
  <mat-icon class='material-icons'>close</mat-icon>
</button>

<app-rabat-kampagne-form [rabatForm]='rabatForm'
                         [isPrivatKunde]='isPrivatKunde'
                         [maxKontantRabat]='maxRabatKontant'
                         class='margin-top' mat-dialog-content></app-rabat-kampagne-form>
<div mat-dialog-actions class='row-reverse'>
  <button mat-raised-button color='primary' (click)='save()' [disabled]='rabatForm.invalid'>Gem</button>
  <button (click)='cancel()' class='modal-cancel' mat-raised-button>Fortryd</button>
</div>
